import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);

// Suppress ResizeObserver loop errors in development overlays
const resizeObserverError = /ResizeObserver loop completed with undelivered notifications/i;
window.addEventListener('error', (event) => {
  if (resizeObserverError.test(event.message)) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});

// Throttle ResizeObserver callbacks to avoid dev overlay spam
if (typeof window !== 'undefined' && window.ResizeObserver) {
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      let throttled = false;
      const wrapped = (entries, observer) => {
        if (throttled) return;
        throttled = true;
        requestAnimationFrame(() => {
          throttled = false;
          callback(entries, observer);
        });
      };
      super(wrapped);
    }
  };
}
